var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7, _circle3, _path8, _path9, _path0, _path1, _circle4, _circle5, _circle6, _circle7, _circle8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImage4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 329,
    viewBox: "0 0 373 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297 175C286.652 187.132 286.5 209 303 222C299 206.5 304.005 195.217 311.5 188C325 175 364 164.5 350 117C337.963 76.1618 357.667 52.1667 372.5 42.5C371.333 41.6667 354.6 32.1 297 0.5C266 61 286.5 88 303 111C319.5 134 311.5 158 297 175Z",
    fill: "url(#paint0_linear_302_11978)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3757 292.139C86.0671 290.824 87.4305 290 88.9164 290H225.556C227.056 290 228.431 290.84 229.115 292.175L245.013 323.175C246.378 325.837 244.445 329 241.453 329H72.6215C69.6124 329 67.6808 325.802 69.0808 323.139L85.3757 292.139Z",
    fill: "#DDDDF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M282.5 269.5C274.5 269.5 267 270.5 263.5 272.5L269.5 276.5L296 278L301 272.5L300 272C298 271 291.5 269.5 282.5 269.5Z",
    fill: "#D1D1EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268.21 308.824L303.147 228",
    stroke: "#A0A6C3",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.749 272C263.194 272 262.234 273.696 263.034 275.029L265.879 279.771C267.317 282.168 266.502 285.298 264.436 287.181C259.82 291.388 254.379 296.407 253.035 307C252.688 309.739 254 312.5 257.722 314.466C273.497 321.173 291.411 321.196 307.177 314.466C310.5 313 312.212 309.739 311.864 307C310.52 296.407 305.079 291.388 300.463 287.181C298.397 285.298 297.582 282.168 299.02 279.771L301.865 275.029C302.665 273.696 301.555 272 300 272C301.858 273.977 289.833 274.721 284.721 274.946C283.236 275.012 281.765 275.013 280.28 274.953C274.888 274.737 261.752 273.998 264.749 272Z",
    fill: "#E5E5F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.163,
    cy: 221.532,
    r: 71,
    fill: "#EFEFFD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.2126,
    cy: 80.2126,
    r: 71.5229,
    transform: "matrix(1 0 0 -1 77 305.163)",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.227 211.421C150.652 214.868 146.063 219.923 140.513 219.107C137.213 218.621 133.699 218.36 130.053 218.36C126.409 218.36 122.897 218.621 119.598 219.106C114.049 219.921 109.46 214.867 113.885 211.42C118.22 208.043 123.872 206 130.055 206C136.239 206 141.892 208.043 146.227 211.421ZM130.178 250.495C130.136 250.496 130.094 250.496 130.053 250.496C130.014 250.496 129.975 250.496 129.936 250.495C129.976 250.496 130.016 250.496 130.055 250.496C130.096 250.496 130.137 250.496 130.178 250.495Z",
    fill: "#A0A6C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.116 211.421C204.541 214.868 199.951 219.923 194.402 219.107C191.101 218.621 187.587 218.36 183.942 218.36C180.298 218.36 176.785 218.621 173.487 219.106C167.937 219.921 163.349 214.867 167.774 211.42C172.108 208.043 177.761 206 183.944 206C190.128 206 195.781 208.043 200.116 211.421ZM184.066 250.495C184.025 250.496 183.983 250.496 183.942 250.496C183.903 250.496 183.864 250.496 183.825 250.495C183.864 250.496 183.904 250.496 183.944 250.496C183.985 250.496 184.025 250.496 184.066 250.495Z",
    fill: "#A0A6C3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3688,
    cy: 13.3688,
    r: 8.6897,
    transform: "matrix(1 0 0 -1 143.844 144.737)",
    fill: "#A0A6C4",
    stroke: "#A0A6C4",
    strokeWidth: 9.35814
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.213 124.685C157.213 151.422 157.213 158.107 157.213 158.107",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237.426 238.319C237.426 216.929 237.426 211.582 237.426 211.582",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M77 238.319C77 216.929 77 211.582 77 211.582",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M130.476 251.688C134.368 259.476 144.869 265.057 157.213 265.057C169.557 265.057 180.059 259.476 183.951 251.688",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 259,
    r: 6,
    fill: "#DEDEF8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 100,
    r: 6,
    fill: "#D7D7ED"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 225 144)",
    fill: "#DCDCF0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 46 184)",
    fill: "#E2E2F8"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 270 241)",
    fill: "#E5E5F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_11978",
    x1: 324.5,
    y1: 36.5,
    x2: 326.712,
    y2: 222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1F3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage4);
export default __webpack_public_path__ + "static/media/emptyImage4.b68f19b1d61f4f2ab99b84a293ee0529.svg";
export { ForwardRef as ReactComponent };